/* ============================================================
   StarOLED Landing Page — UI Logic
   Vanilla JS, no dependencies. Reads copy from STAROLED_COPY
   (js/copy-data.js) and hydrates the DOM on load.
   ============================================================ */
(function () {
  "use strict";

  var C = window.STAROLED_COPY;
  if (!C) {
    console.error("StarOLED: copy-data.js not loaded — aborting hydration.");
    return;
  }

  /* ============================================================
     SHOPIFY CHECKOUT CONFIG — live production variants
     Each style × bundle tier has a dedicated Shopify variant so
     the checkout price always matches the product page price.
     ============================================================ */
  var SHOPIFY_CONFIG = {
    storeDomain: "mcxcgc-u6.myshopify.com",
    variants: {
      "round-small": { pack1: "51661754892583", pack2: "51661754958119", pack4: "51709648077095" },
      "round-large": { pack1: "51661754925351", pack2: "51661754990887", pack4: "51709648109863" },
      "square":      { pack1: "51661755023655", pack2: "51709648044327", pack4: "51709648142631" }
    },
    indoorVariants: {
      black: { pack1: "51687949304103", pack2: "51709648437543", pack4: "51709648503079" },
      white: { pack1: "51687949271335", pack2: "51709648470311", pack4: "51709648535847" }
    }
  };

  /* Resolve the correct variant ID and quantity for Shopify /cart/add */
  function resolveOutdoorVariant(styleId, bundleId) {
    var v = SHOPIFY_CONFIG.variants[styleId];
    if (!v) return null;
    var id = v[bundleId] || v.pack1;
    return { id: id, qty: 1 };
  }

  function resolveIndoorVariant(bundleId, colorId) {
    var v = SHOPIFY_CONFIG.indoorVariants[colorId];
    if (!v) return null;
    var id = v[bundleId] || v.pack1;
    return { id: id, qty: 1 };
  }

  function buildCheckoutUrl(styleId, bundleId) {
    var r = resolveOutdoorVariant(styleId, bundleId);
    if (!r) return null;
    return "https://" + SHOPIFY_CONFIG.storeDomain + "/cart/" + r.id + ":" + r.qty;
  }
  window.buildCheckoutUrl = buildCheckoutUrl;

  function buildIndoorCheckoutUrl(bundleId, colorId) {
    var r = resolveIndoorVariant(bundleId, colorId);
    if (!r) return null;
    return "https://" + SHOPIFY_CONFIG.storeDomain + "/cart/" + r.id + ":" + r.qty;
  }
  window.buildIndoorCheckoutUrl = buildIndoorCheckoutUrl;

  var isShopify = typeof Shopify !== "undefined";

  /* ---------- helpers ---------- */

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  /* ---------- presentment currency -----------------------------------------
     Prices in STYLES and copy-data.js are authored in the shop's base
     currency (USD). Markets are enabled for Canada and the UK, so Shopify
     converts at checkout AND applies that market's rounding rule — a $59.99
     base price was charged as CA$83.00, not the raw FX result of 82.82.
     Multiplying by Shopify.currency.rate here would therefore still print a
     price the customer is not charged.

     So we read the real per-variant presentment prices that Liquid rendered
     into #money-config (snippets/money-config.liquid) — the same source
     checkout bills from — and substitute them before anything renders.
     Every amount is printed with an explicit ISO code so "$" is never
     ambiguous between USD and CAD.

     If the snippet is absent or a variant is unresolved, the authored USD
     value is kept, so the page still renders. */
  var MONEY = (function () {
    var cfg = null;
    try {
      var el = document.getElementById("money-config");
      if (el) cfg = JSON.parse(el.textContent);
    } catch (e) { cfg = null; }

    var code = (cfg && cfg.code) || "USD";
    var prices = (cfg && cfg.prices) || {};

    var fmt = null;
    try {
      fmt = new Intl.NumberFormat(undefined, { style: "currency", currency: code, currencyDisplay: "narrowSymbol" });
    } catch (e) {
      try { fmt = new Intl.NumberFormat(undefined, { style: "currency", currency: code }); } catch (e2) { fmt = null; }
    }

    return {
      code: code,
      hasPrices: function () { for (var k in prices) { return true; } return false; },
      forVariant: function (id) {
        var v = prices[String(id)];
        return typeof v === "number" ? v : null;
      },
      /* n is a major-unit amount ALREADY in the presentment currency. */
      format: function (n) {
        return (fmt ? fmt.format(n) : "$" + n.toFixed(2)) + " " + code;
      }
    };
  })();

  var money = function (n) { return MONEY.format(n); };

  /* Copy-data icon keys → Font Awesome classes */
  var ICONS = {
    sun: "fa-sun", toggle: "fa-toggle-on", shield: "fa-shield-halved",
    spray: "fa-spray-can-sparkles", money: "fa-money-bill-wave", plug: "fa-plug",
    leaf: "fa-leaf", wallet: "fa-wallet", stake: "fa-seedling",
    truck: "fa-truck-fast", "shield-check": "fa-shield-heart",
    lock: "fa-lock", medal: "fa-medal",
    quiet: "fa-volume-low", battery: "fa-battery-full", child: "fa-baby",
    card: "fa-credit-card"
  };
  var icon = function (key, extra) {
    return '<i class="fa-solid ' + (ICONS[key] || "fa-circle-check") + " " + (extra || "") + '" aria-hidden="true"></i>';
  };

  /* Gallery alt text (supplier images are infographics; describe intent) */
  var DEFAULT_IMAGE = 8; // "Square ground type [black]" (matches default "square" style)
  var ALT = {
    1: "StarOLED lamp glowing purple in a landscaped garden at night",
    6: "StarOLED Round Small compact solar UV insect trap staked beside a garden path",
    7: "StarOLED Round Large high-capacity solar UV insect trap in a backyard",
    8: "StarOLED Premium Square heavy-duty solar UV insect trap in a backyard",
    14: "Three StarOLED lamps in UV trap mode lighting a lawn at dusk",
    16: "StarOLED lamps in white light mode lining a courtyard path",
    18: "StarOLED product dimensions and technical specifications"
  };
  var altFor = function (i) { return ALT[i] || ("StarOLED 2-in-1 solar UV insect trap — product image " + i); };

  /* ---------- asset URL helper ---------- */

  function assetUrl(filename) {
    if (isShopify) {
      var link = document.querySelector('link[href*="/style.css"]');
      if (link) return link.href.replace(/\/style\.css.*$/, '/' + filename);
    }
    return "assets/" + filename;
  }

  function indoorAssetUrl(filename) {
    if (isShopify) return assetUrl("indoor-" + filename);
    return "assets/indoor/" + filename;
  }

  /* ---------- application state ---------- */

  /* Design styles reflecting real TeemDrop stock.
     `image` = asset index shown in the hero when the style is selected. */
  /* Style-based dynamic pricing.

     PRICING INTEGRITY RULE — read before editing:
     Each style declares ONLY its real selling price per tier. The
     "compare at" figure is never hand-typed; it is DERIVED as
     (single-unit price x quantity), i.e. what the same number of units
     would genuinely cost bought individually at today's listed price.

     This keeps every reference price a bona fide, currently-offered
     price, as required by FTC deceptive-pricing guidance, Meta's
     Unacceptable Business Practices policy and TikTok's Deceptive
     Practices policy. Never reintroduce a hard-coded compareAt — an
     invented "was" price is the single most common cause of ad-account
     and domain-level bans in e-commerce. */
  var STYLES = [
    {
      id: "round-small",
      name: "Round Small",
      tag: "Compact",
      desc: "Budget-friendly landscape path light.",
      image: 6,
      pricing: {
        pack1: { price: 24.99 },
        pack2: { price: 39.99 },
        pack4: { price: 69.99 }
      }
    },
    {
      id: "round-large",
      name: "Round Large",
      tag: "High-Capacity",
      desc: "Expanded solar-panel yard protection.",
      image: 7,
      pricing: {
        pack1: { price: 29.99 },
        pack2: { price: 49.99 },
        pack4: { price: 89.99 }
      }
    },
    {
      id: "square",
      name: "Premium Square",
      tag: "Heavy-Duty",
      desc: "Max 360° zapping perimeter light.",
      image: 8, /* "Square ground type [black]" — same series as 6/7 */
      pricing: {
        pack1: { price: 34.99 },
        pack2: { price: 59.99 },
        pack4: { price: 99.99 }
      }
    }
  ];

  /* Effective outdoor price for the current (or given) style + bundle tier.
     `compareAt` and `saving` are derived from the real single-unit price and
     are null for the 1-pack (nothing to compare a single unit against). */
  function outdoorPricing(bundleId, styleId) {
    var s = getStyle(styleId || state.styleId);
    var b = getBundle(bundleId);
    var p = s.pricing[bundleId] || s.pricing.pack1;
    var single = s.pricing.pack1.price;
    var compareAt = b.qty > 1 ? Math.round(single * b.qty * 100) / 100 : null;
    var saving = compareAt ? Math.round((compareAt - p.price) * 100) / 100 : null;
    return {
      price: p.price,
      compareAt: compareAt,
      saving: saving,
      perUnit: p.price / b.qty
    };
  }

  /* Swap the authored USD figures for the real presentment prices before
     anything renders. Runs once, from init(). Anything that cannot be
     resolved keeps its authored value. */
  function applyPresentmentPrices() {
    if (!MONEY.hasPrices()) return;

    STYLES.forEach(function (s) {
      Object.keys(s.pricing).forEach(function (packId) {
        var r = resolveOutdoorVariant(s.id, packId);
        var real = r ? MONEY.forVariant(r.id) : null;
        if (real !== null) s.pricing[packId].price = real;
      });
    });

    var colors = C.indoor && C.indoor.colors;
    var colorId = colors && colors[0] ? colors[0].id : null;
    if (!colorId) return;

    var r1 = resolveIndoorVariant("pack1", colorId);
    var single = r1 ? MONEY.forVariant(r1.id) : null;

    C.indoor.bundles.options.forEach(function (b) {
      var r = resolveIndoorVariant(b.id, colorId);
      var real = r ? MONEY.forVariant(r.id) : null;
      if (real === null) return;
      b.price = real;
      b.perUnit = real / b.qty;
      /* Same integrity rule as indoorPricing(): what this many units would
         genuinely cost bought singly, at today's price, in this currency. */
      b.compareAt = (single !== null && b.qty > 1)
        ? Math.round(single * b.qty * 100) / 100
        : null;
    });
  }

  var state = {
    bundleId: "pack2",  // default: 2-Pack best-seller
    styleId: "square"   // default: Premium Square 360°
  };

  /* Indoor tab keeps fully independent selection state. */
  var indoorState = {
    bundleId: "pack2",  // default: Living Room + Bedroom Combo
    colorId: "black"    // default: Midnight Black
  };

  /* Which collection tab is active: "outdoor" | "indoor" */
  var activeCollection = "outdoor";

  var getIndoorBundle = function (id) {
    for (var i = 0; i < C.indoor.bundles.options.length; i++) {
      if (C.indoor.bundles.options[i].id === id) return C.indoor.bundles.options[i];
    }
    return C.indoor.bundles.options[0];
  };

  var getIndoorColor = function (id) {
    for (var i = 0; i < C.indoor.colors.length; i++) {
      if (C.indoor.colors[i].id === id) return C.indoor.colors[i];
    }
    return C.indoor.colors[0];
  };

  var getBundle = function (id) {
    for (var i = 0; i < C.bundles.options.length; i++) {
      if (C.bundles.options[i].id === id) return C.bundles.options[i];
    }
    return C.bundles.options[0];
  };

  var getStyle = function (id) {
    for (var i = 0; i < STYLES.length; i++) {
      if (STYLES[i].id === id) return STYLES[i];
    }
    return STYLES[0];
  };

  /* ---------- update cart form hidden fields ---------- */

  function syncOutdoorForm() {
    var resolved = resolveOutdoorVariant(state.styleId, state.bundleId);
    var idField = $("#outdoor-variant-id");
    var qtyField = $("#outdoor-quantity");
    if (idField && resolved) {
      idField.value = resolved.id;
      qtyField.value = resolved.qty;
    }
  }

  function syncIndoorForm() {
    var resolved = resolveIndoorVariant(indoorState.bundleId, indoorState.colorId);
    var idField = $("#indoor-variant-id");
    var qtyField = $("#indoor-quantity");
    if (idField && resolved) {
      idField.value = resolved.id;
      qtyField.value = resolved.qty;
    }
  }

  /* ---------- 1. dynamic content injection ---------- */

  function renderHero() {
    $("#hero-super").textContent = C.hero.superHeadline;
    $("#hero-headline").textContent = C.hero.headline;
    $("#hero-subheadline").textContent = C.hero.subheadline;
    $("#cta-urgency").innerHTML = '<i class="fa-solid fa-truck-fast mr-1" aria-hidden="true"></i> ' + C.hero.cta.urgency;

    $("#hero-bullets").innerHTML = C.hero.bullets.map(function (b) {
      return (
        '<li class="flex gap-3">' +
          '<span class="shrink-0 w-9 h-9 rounded-lg bg-solar-600/15 text-solar-400 flex items-center justify-center">' + icon(b.icon) + "</span>" +
          '<p class="text-white/85 text-[15px] leading-snug"><strong class="text-white font-bold">' + b.title + ":</strong> " + b.text + "</p>" +
        "</li>"
      );
    }).join("");
  }

  function renderTrustBadges() {
    $("#trust-badges").innerHTML = C.trust.badges.map(function (b) {
      return (
        '<div class="flex flex-col sm:flex-row items-center justify-center gap-2 text-pine-800">' +
          icon(b.icon, "text-solar-600 text-xl") +
          '<span class="text-sm font-bold">' + b.label + "</span>" +
        "</div>"
      );
    }).join("");
  }

  function renderPainPleasure() {
    $("#pp-heading").textContent = C.painPleasure.heading;
    $("#pp-subheading").textContent = C.painPleasure.subheading;

    var item = function (p, dark) {
      return (
        '<li class="flex gap-3">' +
          '<span class="shrink-0 w-9 h-9 rounded-lg ' + (dark ? "bg-solar-600/20 text-solar-400" : "bg-red-50 text-red-600") + ' flex items-center justify-center">' + icon(p.icon) + "</span>" +
          "<div>" +
            '<p class="font-display font-bold ' + (dark ? "text-white" : "text-pine-900") + '">' + p.title + "</p>" +
            '<p class="text-[15px] leading-relaxed mt-1 ' + (dark ? "text-white/75" : "text-ink/70") + '">' + p.text + "</p>" +
          "</div>" +
        "</li>"
      );
    };
    $("#pain-list").innerHTML = C.painPleasure.pains.map(function (p) { return item(p, false); }).join("");
    $("#pleasure-list").innerHTML = C.painPleasure.pleasures.map(function (p) { return item(p, true); }).join("");
  }

  function renderTestimonials(collection) {
    var t = collection === "indoor" ? C.indoor.testimonials : C.testimonials;
    $("#testimonials-heading").textContent = t.heading;
    $("#testimonials-subheading").textContent = t.subheading;

    var grid = $("#testimonial-cards");

    /* No hand-written reviews exist (see copy-data.js). When Judge.me has
       collected real ones it renders them in its own widget below this grid,
       so here we show an honest empty state rather than inventing social
       proof. Never replace this with placeholder review cards. */
    if (!t.reviews || t.reviews.length === 0) {
      var empty = t.emptyState || {};
      grid.className = "mt-10";
      grid.innerHTML =
        '<div class="rounded-2xl bg-white border border-pine-100 p-8 md:p-10 text-center max-w-2xl mx-auto">' +
          '<i class="fa-regular fa-comments text-3xl text-pine-300 mb-4" aria-hidden="true"></i>' +
          '<p class="font-display font-bold text-pine-900 text-lg">' + (empty.title || "No reviews yet") + "</p>" +
          '<p class="text-[15px] text-ink/70 leading-relaxed mt-2">' + (empty.text || "") + "</p>" +
        "</div>";
      return;
    }

    grid.className = "reviews-grid mt-10";
    grid.innerHTML = t.reviews.map(function (r) {
      var stars = "";
      for (var i = 0; i < 5; i++) {
        stars += '<i class="fa-solid fa-star ' + (i < r.rating ? "text-solar-500" : "text-pine-100") + '" aria-hidden="true"></i>';
      }
      var imageHtml = r.image
        ? '<div class="mt-3 rounded-lg overflow-hidden"><img src="' + r.image + '" alt="Photo by ' + r.name + '" class="w-full h-40 object-cover" loading="lazy" width="400" height="160"></div>'
        : "";
      return (
        '<figure class="rounded-2xl bg-white border border-pine-100 p-6 flex flex-col">' +
          '<div class="flex items-center justify-between">' +
            '<div class="flex gap-0.5" aria-label="Rated ' + r.rating + ' out of 5 stars">' + stars + "</div>" +
            '<span class="text-xs font-bold text-pine-700 bg-pine-50 rounded-full px-2.5 py-1">' + r.highlight + "</span>" +
          "</div>" +
          imageHtml +
          '<blockquote class="mt-4 flex-1">' +
            '<p class="font-display font-bold text-pine-900">&ldquo;' + r.title + '&rdquo;</p>' +
            '<p class="text-[15px] text-ink/70 leading-relaxed mt-2">' + r.text + "</p>" +
          "</blockquote>" +
          '<figcaption class="mt-4 pt-4 border-t border-pine-100 flex items-center gap-2 text-sm">' +
            '<span class="font-bold text-pine-900">' + r.name + "</span>" +
            '<span class="text-ink/50">· ' + r.location + "</span>" +
            /* A "Verified" badge may ONLY be shown for a review that came
               through a verified-purchase flow (i.e. Judge.me). It is
               deliberately not rendered for theme-supplied reviews. */
          "</figcaption>" +
        "</figure>"
      );
    }).join("");
  }

  function renderGuarantee() {
    $("#guarantee-heading").textContent = C.trust.guarantee.heading;
    $("#guarantee-text").textContent = C.trust.guarantee.text;
  }

  /* FAQ accordion with smooth max-height transitions */
  function renderFAQ(collection) {
    var faqs = collection === "indoor" ? C.indoor.faqs : C.faqs;
    $("#faq-heading").textContent = faqs.heading;

    $("#faq-accordion").innerHTML = faqs.items.map(function (f, i) {
      return (
        '<div class="faq-item rounded-xl bg-white border border-pine-100 overflow-hidden">' +
          '<button type="button" class="faq-toggle cursor-pointer w-full flex items-center justify-between gap-4 text-left font-display font-bold text-pine-900 px-5 py-4" aria-expanded="false" aria-controls="faq-panel-' + i + '">' +
            "<span>" + f.q + "</span>" +
            '<i class="fa-solid fa-chevron-down shrink-0 text-solar-600 transition-transform duration-300" aria-hidden="true"></i>' +
          "</button>" +
          '<div id="faq-panel-' + i + '" class="faq-panel max-h-0 overflow-hidden transition-[max-height] duration-300 ease-out">' +
            '<p class="px-5 pb-5 text-[15px] text-ink/70 leading-relaxed">' + f.a + "</p>" +
          "</div>" +
        "</div>"
      );
    }).join("");

    $$(".faq-toggle").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute("aria-expanded") === "true";

        /* close any other open item first */
        $$(".faq-toggle").forEach(function (other) {
          if (other !== btn && other.getAttribute("aria-expanded") === "true") {
            other.setAttribute("aria-expanded", "false");
            other.nextElementSibling.style.maxHeight = "0px";
            other.querySelector("i").style.transform = "";
          }
        });

        btn.setAttribute("aria-expanded", String(!open));
        panel.style.maxHeight = open ? "0px" : panel.scrollHeight + "px";
        btn.querySelector("i").style.transform = open ? "" : "rotate(180deg)";
      });
    });
  }

  /* ---------- 2. product gallery ---------- */

  var ACTIVE_THUMB = ["ring-2", "ring-solar-500", "opacity-100"];
  var INACTIVE_THUMB = ["ring-1", "ring-white/15", "opacity-70"];

  /* 12.webp shows a competitor brand — never render it */
  var BLOCKED_IMAGES = [12];

  function selectImage(index) {
    if (BLOCKED_IMAGES.indexOf(index) !== -1) return;
    var main = $("#main-image");
    main.src = assetUrl(index + ".webp");
    main.alt = altFor(index);

    /* retrigger the fade-in on every swap */
    main.classList.remove("img-fade");
    void main.offsetWidth; /* reflow so the animation restarts */
    main.classList.add("img-fade");

    $$(".thumb").forEach(function (t) {
      var active = Number(t.dataset.index) === index;
      ACTIVE_THUMB.forEach(function (c) { t.classList.toggle(c, active); });
      INACTIVE_THUMB.forEach(function (c) { t.classList.toggle(c, !active); });
      t.setAttribute("aria-selected", String(active));
      if (active) t.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    });
  }

  function initGallery() {
    $$(".thumb").forEach(function (t) {
      var idx = Number(t.dataset.index);
      if (BLOCKED_IMAGES.indexOf(idx) !== -1) {
        t.remove(); // strip blocked thumbnails from the DOM entirely
        return;
      }
      t.addEventListener("click", function () { selectImage(idx); });
    });
    selectImage(DEFAULT_IMAGE); // bypass images with heavy baked-in text
  }

  /* ---------- 2a. gallery arrow navigation (prev / next, wrapping) ----------
     Reads the live, VISIBLE thumbnails at click time — so removed (blocked)
     and hidden (missing-image) thumbs are naturally skipped — then steps to
     the neighbouring index and delegates to the existing select function,
     which keeps the active-thumbnail state in sync. */
  function cycleGallery(thumbSelector, selectFn, dir) {
    var thumbs = $$(thumbSelector).filter(function (t) {
      return t.offsetParent !== null; // visible only (display:none → null)
    });
    if (!thumbs.length) return;

    var current = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute("aria-selected") === "true") { current = i; break; }
    }
    var nextPos = (current + dir + thumbs.length) % thumbs.length;
    selectFn(Number(thumbs[nextPos].dataset.index));
  }

  function prevProductImage() { cycleGallery(".thumb", selectImage, -1); }
  function nextProductImage() { cycleGallery(".thumb", selectImage, 1); }
  window.prevProductImage = prevProductImage;
  window.nextProductImage = nextProductImage;

  function prevIndoorImage() { cycleGallery(".thumb-in", selectIndoorImage, -1); }
  function nextIndoorImage() { cycleGallery(".thumb-in", selectIndoorImage, 1); }
  window.prevIndoorImage = prevIndoorImage;
  window.nextIndoorImage = nextIndoorImage;

  function initGalleryArrows() {
    var bind = function (id, fn) {
      var el = $(id);
      if (el) el.addEventListener("click", fn);
    };
    bind("#gallery-prev", prevProductImage);
    bind("#gallery-next", nextProductImage);
    bind("#gallery-prev-indoor", prevIndoorImage);
    bind("#gallery-next-indoor", nextIndoorImage);
  }

  /* ---------- 2c. fullscreen lightbox ----------
     Reuses each gallery's live visible thumbnails so the same image set powers
     both the inline gallery and the fullscreen viewer. Supports arrows, Esc /
     arrow keys, and touch swipe. Cycling the lightbox also drives the underlying
     gallery, so closing leaves the shopper on the last image they viewed. */
  var lightbox = {
    el: null, img: null, counter: null,
    thumbSel: ".thumb", selectFn: null, open: false
  };

  function lbThumbs() {
    return $$(lightbox.thumbSel).filter(function (t) { return t.offsetParent !== null; });
  }

  function lbCurrentIndex() {
    var main = lightbox.thumbSel === ".thumb-in" ? $("#main-image-indoor") : $("#main-image");
    return main.getAttribute("src");
  }

  function lbSync() {
    var src = lightbox.thumbSel === ".thumb-in" ? $("#main-image-indoor").src : $("#main-image").src;
    lightbox.img.classList.add("fading");
    var apply = function () {
      lightbox.img.src = src;
      lightbox.img.alt = (lightbox.thumbSel === ".thumb-in" ? $("#main-image-indoor") : $("#main-image")).alt;
      lightbox.img.classList.remove("fading");
    };
    if (lightbox.img.complete) setTimeout(apply, 120); else apply();
    var thumbs = lbThumbs();
    var pos = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute("aria-selected") === "true") { pos = i; break; }
    }
    lightbox.counter.textContent = (pos + 1) + " / " + thumbs.length;
  }

  function openLightbox(collection) {
    lightbox.thumbSel = collection === "indoor" ? ".thumb-in" : ".thumb";
    lightbox.selectFn = collection === "indoor" ? selectIndoorImage : selectImage;
    lightbox.el.hidden = false;
    void lightbox.el.offsetWidth;
    lightbox.el.classList.add("open");
    lightbox.open = true;
    document.body.style.overflow = "hidden";
    lbSync();
  }

  function closeLightbox() {
    lightbox.el.classList.remove("open");
    lightbox.open = false;
    document.body.style.overflow = "";
    setTimeout(function () { if (!lightbox.open) lightbox.el.hidden = true; }, 260);
  }

  function lightboxStep(dir) {
    cycleGallery(lightbox.thumbSel, lightbox.selectFn, dir);
    lbSync();
  }

  function initLightbox() {
    lightbox.el = $("#lightbox");
    lightbox.img = $("#lightbox-img");
    lightbox.counter = $("#lightbox-counter");
    if (!lightbox.el) return;

    $("#main-image").addEventListener("click", function () { openLightbox("outdoor"); });
    $("#main-image-indoor").addEventListener("click", function () { openLightbox("indoor"); });
    $("#lightbox-close").addEventListener("click", closeLightbox);
    $("#lightbox-prev").addEventListener("click", function () { lightboxStep(-1); });
    $("#lightbox-next").addEventListener("click", function () { lightboxStep(1); });
    /* click the dark backdrop (not the image/buttons) to close */
    lightbox.el.addEventListener("click", function (e) {
      if (e.target === lightbox.el) closeLightbox();
    });

    document.addEventListener("keydown", function (e) {
      if (!lightbox.open) return;
      if (e.key === "Escape") closeLightbox();
      else if (e.key === "ArrowLeft") lightboxStep(-1);
      else if (e.key === "ArrowRight") lightboxStep(1);
    });

    /* touch swipe */
    var startX = 0, startY = 0, tracking = false;
    lightbox.el.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    lightbox.el.addEventListener("touchend", function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) lightboxStep(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------- 2d. checkout trust badges + stock badge ---------- */

  function renderCheckoutBadges() {
    var html = C.trust.checkoutBadges.map(function (b) {
      return '<span class="checkout-badge">' + icon(b.icon) + "<span>" + b.label + "</span></span>";
    }).join("");
    $$("#checkout-badges, #checkout-badges-in").forEach(function (el) { el.innerHTML = html; });
  }

  /* Stock badge — honest by design: shows a real, finite count only when one is
     provided (COPY.scarcity, bound to Shopify inventory_quantity in the theme);
     otherwise a neutral "In Stock" state. Never fabricates or auto-decrements. */
  function renderStockBadge(elId, count) {
    var el = $(elId);
    if (!el) return;
    var s = C.scarcity;
    if (typeof count === "number" && count > 0 && count <= s.lowThreshold) {
      el.className = "stock-badge is-low";
      el.innerHTML = '<span class="stock-dot"></span> Only ' + count + " left in stock";
    } else {
      el.className = "stock-badge";
      el.innerHTML = '<span class="stock-dot"></span> ' + s.inStockLabel;
    }
  }

  /* ---------- 2e. modals (track order, shipping policy) ---------- */

  function initModals() {
    var lastFocus = null;
    function openModal(sel) {
      var m = $(sel);
      if (!m) return;
      lastFocus = document.activeElement;
      m.hidden = false;
      void m.offsetWidth;
      m.classList.add("open");
      document.body.style.overflow = "hidden";
      var f = m.querySelector("input, button");
      if (f) f.focus();
    }
    function closeModal(m) {
      m.classList.remove("open");
      document.body.style.overflow = "";
      setTimeout(function () { if (!m.classList.contains("open")) m.hidden = true; }, 260);
      if (lastFocus) lastFocus.focus();
    }
    $$("[data-modal-open]").forEach(function (btn) {
      btn.addEventListener("click", function () { openModal(btn.getAttribute("data-modal-open")); });
    });
    $$(".modal").forEach(function (m) {
      m.addEventListener("click", function (e) {
        if (e.target === m || e.target.hasAttribute("data-modal-close")) closeModal(m);
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      $$(".modal.open").forEach(closeModal);
    });

    /* guard empty track submissions (avoid a blank query to the tracking app) */
    var tf = $("#track-form");
    if (tf) tf.addEventListener("submit", function (e) {
      var order = $("#track-order").value.trim();
      var email = $("#track-email").value.trim();
      if (!order && !email) { e.preventDefault(); $("#track-order").focus(); }
    });
  }

  /* ---------- 2f. newsletter + header shop-jump ---------- */

  function initNewsletter() {
    var form = $("#newsletter-form");
    /* On Shopify the newsletter is a {% form 'customer' %} block (this id lands
       on a <div>, not a <form>) — leave it alone so it posts natively. Only the
       static preview's real <form> gets the inline-confirm fallback. */
    if (!form || form.tagName !== "FORM" || form.getAttribute("action")) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      form.hidden = true;
      $("#newsletter-ok").hidden = false;
    });
  }

  function initBuyJump() {
    $$("[data-buy-jump]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        var sel = activeCollection === "indoor" ? "#bundle-container-in" : "#bundle-container";
        var t = $(sel);
        if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }

  /* ---------- 2b. design style selector ---------- */

  function renderStyles() {
    $("#style-container").innerHTML = STYLES.map(function (s) {
      return (
        '<button type="button" role="radio" aria-checked="false" data-style="' + s.id + '"' +
          ' class="style-card cursor-pointer relative text-left rounded-xl border-2 p-3 transition duration-200 flex items-center gap-3 sm:flex-col sm:items-stretch">' +
          '<span class="style-check hidden absolute top-2 right-2 z-10 w-6 h-6 rounded-full bg-emerald-400 text-pine-950 flex items-center justify-center">' +
            '<i class="fa-solid fa-check text-xs" aria-hidden="true"></i>' +
          "</span>" +
          '<img src="' + assetUrl(s.image + '.webp') + '" alt="" loading="lazy" width="96" height="96"' +
            ' style="object-position:72% 35%"' +
            ' class="shrink-0 w-16 h-16 sm:w-full sm:h-24 rounded-lg object-cover bg-white/5">' +
          '<span class="min-w-0">' +
            '<span class="block font-display font-bold text-white text-[14px] leading-snug sm:mt-2">' + s.name + "</span>" +
            '<span class="block text-[10px] font-extrabold uppercase tracking-wide text-solar-400 mt-0.5">' + s.tag + "</span>" +
            '<span class="block text-[12px] text-white/60 leading-snug mt-1">' + s.desc + "</span>" +
          "</span>" +
        "</button>"
      );
    }).join("");

    $$(".style-card").forEach(function (card) {
      card.addEventListener("click", function () { selectStyle(card.dataset.style); });
    });
  }

  function selectStyle(id) {
    state.styleId = id;
    var s = getStyle(id);

    $$(".style-card").forEach(function (card) {
      var active = card.dataset.style === id;
      card.setAttribute("aria-checked", String(active));
      card.classList.toggle("border-emerald-400", active);
      card.classList.toggle("bg-emerald-400/10", active);
      card.classList.toggle("border-white/15", !active);
      card.classList.toggle("bg-white/5", !active);
      card.querySelector(".style-check").classList.toggle("hidden", !active);
    });

    /* swap the hero gallery to the matching variant image */
    selectImage(s.image);

    /* re-price the bundle cards for this style, then re-sync the CTA + sticky
       bar so the whole checkout reflects the active style/bundle combination */
    renderBundles();
    selectBundle(state.bundleId);
  }

  /* ---------- 3. bundle state management ---------- */

  function renderBundles() {
    $("#bundle-heading").textContent = "Step 2: " + C.bundles.heading;

    $("#bundle-container").innerHTML = C.bundles.options.map(function (b) {
      var pr = outdoorPricing(b.id);
      return (
        '<button type="button" role="radio" aria-checked="false" data-bundle="' + b.id + '"' +
          ' class="bundle-card cursor-pointer w-full text-left rounded-xl border-2 p-4 transition duration-200 flex items-center gap-4">' +
          '<span class="radio-dot shrink-0 w-5 h-5 rounded-full border-2 border-white/40 flex items-center justify-center">' +
            '<span class="dot hidden w-2.5 h-2.5 rounded-full bg-solar-500"></span>' +
          "</span>" +
          '<span class="min-w-0 flex-1">' +
            '<span class="flex flex-wrap items-center gap-2">' +
              '<span class="font-display font-bold text-white">' + b.qty + " Pack — " + b.name + "</span>" +
              (b.badge ? '<span class="text-[11px] font-extrabold uppercase tracking-wide bg-solar-600 text-white rounded-full px-2 py-0.5">' + b.badge + "</span>" : "") +
            "</span>" +
            '<span class="block text-sm text-white/60 mt-0.5">' + b.shippingLabel +
              (pr.saving ? ' · <span class="text-solar-400 font-bold">Save ' + money(pr.saving) + "</span>" : "") +
            "</span>" +
          "</span>" +
          '<span class="text-right shrink-0">' +
            '<span class="block font-display font-extrabold text-white text-lg">' + money(pr.price) + "</span>" +
            /* Reference price is stated in words, not a bare strikethrough, so the
               comparison being made is unambiguous. See outdoorPricing(). */
            (pr.compareAt
              ? '<span class="block text-[11px] text-white/45">' + money(pr.compareAt) + " if bought singly</span>"
              : "") +
            '<span class="block text-[11px] text-solar-400 font-bold">' + money(pr.perUnit) + "/unit</span>" +
          "</span>" +
        "</button>"
      );
    }).join("");

    $$(".bundle-card").forEach(function (card) {
      card.addEventListener("click", function () { selectBundle(card.dataset.bundle); });
    });
  }

  function selectBundle(id) {
    state.bundleId = id;
    var b = getBundle(id);

    $$(".bundle-card").forEach(function (card) {
      var active = card.dataset.bundle === id;
      card.setAttribute("aria-checked", String(active));
      card.classList.toggle("border-solar-500", active);
      card.classList.toggle("bg-solar-600/10", active);
      card.classList.toggle("border-white/15", !active);
      card.classList.toggle("bg-white/5", !active);
      card.querySelector(".dot").classList.toggle("hidden", !active);
      card.querySelector(".radio-dot").classList.toggle("border-solar-500", active);
    });

    var pr = outdoorPricing(id);
    $("#main-cta").innerHTML =
      '<i class="fa-solid fa-cart-plus mr-2" aria-hidden="true"></i>Add ' + b.qty + 'x StarOLED to Cart — ' + money(pr.price);

    syncOutdoorForm();

    if (activeCollection === "outdoor") updateStickyBar();
  }

  /* ---------- 3b. indoor collection: hero, gallery, bundles ---------- */

  function renderIndoorHero() {
    var IH = C.indoor.hero;
    $("#hero-super-in").textContent = IH.superHeadline;
    $("#hero-headline-in").textContent = IH.headline;
    $("#hero-subheadline-in").textContent = IH.subheadline;
    /* The rating row stays hidden unless a REAL aggregate rating exists.
       copy-data.js ships ratingText as null on purpose — populate it only
       from Judge.me verified-purchase data, never by hand. */
    var ratingRow = $("#rating-row-in");
    if (IH.ratingText) {
      $("#rating-text-in").textContent = IH.ratingText;
      ratingRow.setAttribute("aria-label", "Rated " + IH.ratingText);
      ratingRow.hidden = false;
    } else {
      $("#rating-text-in").textContent = "";
      ratingRow.removeAttribute("aria-label");
      ratingRow.hidden = true;
    }
    $("#cta-urgency-in").innerHTML = '<i class="fa-solid fa-truck-fast mr-1" aria-hidden="true"></i> ' + IH.cta.urgency;

    $("#hero-bullets-in").innerHTML = IH.bullets.map(function (b) {
      return (
        '<li class="flex gap-3">' +
          '<span class="shrink-0 w-9 h-9 rounded-lg bg-solar-600/15 text-solar-400 flex items-center justify-center">' + icon(b.icon) + "</span>" +
          '<p class="text-white/85 text-[15px] leading-snug"><strong class="text-white font-bold">' + b.title + ":</strong> " + b.text + "</p>" +
        "</li>"
      );
    }).join("");
  }

  function selectIndoorImage(index) {
    var main = $("#main-image-indoor");
    main.style.visibility = ""; /* undo a previous onerror hide before retrying */
    main.src = indoorAssetUrl(index + ".webp");
    main.alt = C.indoor.gallery.alt[index] || (C.indoor.product.shortName + " — product image " + index);

    main.classList.remove("img-fade");
    void main.offsetWidth;
    main.classList.add("img-fade");

    $$(".thumb-in").forEach(function (t) {
      var active = Number(t.dataset.index) === index;
      ACTIVE_THUMB.forEach(function (c) { t.classList.toggle(c, active); });
      INACTIVE_THUMB.forEach(function (c) { t.classList.toggle(c, !active); });
      t.setAttribute("aria-selected", String(active));
      if (active) t.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    });
  }

  function initIndoorGallery() {
    $$(".thumb-in").forEach(function (t) {
      t.addEventListener("click", function () { selectIndoorImage(Number(t.dataset.index)); });
    });
  }

  /* ---------- indoor color selector (Step 1) ---------- */

  function renderIndoorColors() {
    $("#color-container-in").innerHTML = C.indoor.colors.map(function (c) {
      return (
        '<button type="button" role="radio" aria-checked="false" data-color="' + c.id + '" class="color-swatch">' +
          '<span class="swatch-dot" style="background:' + c.swatch + '" aria-hidden="true"></span>' +
          "<span>" + c.name + "</span>" +
        "</button>"
      );
    }).join("");

    $$(".color-swatch").forEach(function (btn) {
      btn.addEventListener("click", function () { selectIndoorColor(btn.dataset.color); });
    });
  }

  function selectIndoorColor(id) {
    indoorState.colorId = id;
    var c = getIndoorColor(id);

    $$(".color-swatch").forEach(function (btn) {
      btn.setAttribute("aria-checked", String(btn.dataset.color === id));
    });

    selectIndoorImage(c.image);
    syncIndoorForm();
    updateStickyBar();
  }

  /* Indoor reference pricing — same integrity rule as outdoorPricing():
     compare-at is derived from the real 1-pack price x quantity, never
     hand-typed. Returns nulls for the 1-pack. */
  function indoorPricing(b) {
    var single = C.indoor.bundles.options[0].price;
    var compareAt = b.qty > 1 ? Math.round(single * b.qty * 100) / 100 : null;
    var saving = compareAt ? Math.round((compareAt - b.price) * 100) / 100 : null;
    return { compareAt: compareAt, saving: saving };
  }

  function renderIndoorBundles() {
    $("#bundle-heading-in").textContent = "Step 2: " + C.indoor.bundles.heading;

    $("#bundle-container-in").innerHTML = C.indoor.bundles.options.map(function (b) {
      var pr = indoorPricing(b);
      return (
        '<button type="button" role="radio" aria-checked="false" data-bundle="' + b.id + '"' +
          ' class="bundle-card bundle-card-in cursor-pointer w-full text-left rounded-xl border-2 p-4 transition duration-200 flex items-center gap-4">' +
          '<span class="radio-dot shrink-0 w-5 h-5 rounded-full border-2 border-white/40 flex items-center justify-center">' +
            '<span class="dot hidden w-2.5 h-2.5 rounded-full bg-solar-500"></span>' +
          "</span>" +
          '<span class="min-w-0 flex-1">' +
            '<span class="flex flex-wrap items-center gap-2">' +
              '<span class="font-display font-bold text-white">' + b.qty + " Pack — " + b.name + "</span>" +
              (b.badge ? '<span class="text-[11px] font-extrabold uppercase tracking-wide bg-solar-600 text-white rounded-full px-2 py-0.5">' + b.badge + "</span>" : "") +
            "</span>" +
            '<span class="block text-sm text-white/60 mt-0.5">' + b.shippingLabel +
              (pr.saving ? ' · <span class="text-solar-400 font-bold">Save ' + money(pr.saving) + "</span>" : "") +
            "</span>" +
          "</span>" +
          '<span class="text-right shrink-0">' +
            '<span class="block font-display font-extrabold text-white text-lg">' + money(b.price) + "</span>" +
            (pr.compareAt
              ? '<span class="block text-[11px] text-white/45">' + money(pr.compareAt) + " if bought singly</span>"
              : "") +
            '<span class="block text-[11px] text-solar-400 font-bold">' + money(b.perUnit) + "/unit</span>" +
          "</span>" +
        "</button>"
      );
    }).join("");

    $$(".bundle-card-in").forEach(function (card) {
      card.addEventListener("click", function () { selectIndoorBundle(card.dataset.bundle); });
    });
  }

  function selectIndoorBundle(id) {
    indoorState.bundleId = id;
    var b = getIndoorBundle(id);

    $$(".bundle-card-in").forEach(function (card) {
      var active = card.dataset.bundle === id;
      card.setAttribute("aria-checked", String(active));
      card.classList.toggle("border-solar-500", active);
      card.classList.toggle("bg-solar-600/10", active);
      card.classList.toggle("border-white/15", !active);
      card.classList.toggle("bg-white/5", !active);
      card.querySelector(".dot").classList.toggle("hidden", !active);
      card.querySelector(".radio-dot").classList.toggle("border-solar-500", active);
    });

    $("#main-cta-in").innerHTML =
      '<i class="fa-solid fa-cart-plus mr-2" aria-hidden="true"></i>Add ' + b.qty + 'x to Cart — ' + money(b.price);

    syncIndoorForm();
    updateStickyBar();
  }

  /* ---------- 3c. collection tab switcher ---------- */

  function positionTabThumb() {
    var active = $('.tab-btn[aria-selected="true"]');
    var thumb = $(".tab-thumb");
    if (!active || !thumb) return;
    thumb.style.width = active.offsetWidth + "px";
    thumb.style.transform = "translateX(" + active.offsetLeft + "px)";
  }

  function setHeaderHeightVar() {
    var h = $("#site-header");
    if (h) document.documentElement.style.setProperty("--header-h", h.offsetHeight + "px");
  }

  function setCollection(id) {
    activeCollection = id;
    var outdoor = id === "outdoor";

    $("#hero").classList.toggle("hidden", !outdoor);
    $("#hero-indoor").classList.toggle("hidden", outdoor);

    /* swap the environment-specific sections so every block matches the tab */
    $("#features-outdoor").classList.toggle("hidden", !outdoor);
    $("#features-indoor").classList.toggle("hidden", outdoor);
    $("#anywhere-indoor").classList.toggle("hidden", outdoor);
    renderTestimonials(id);
    renderFAQ(id);

    $$(".tab-btn").forEach(function (btn) {
      btn.setAttribute("aria-selected", String(btn.dataset.collection === id));
    });
    positionTabThumb();
    updateStickyBar();
    /* re-evaluate sticky-bar visibility against the newly visible CTA */
    window.dispatchEvent(new Event("scroll"));
  }

  function initCollectionTabs() {
    $$(".tab-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.dataset.collection !== activeCollection) setCollection(btn.dataset.collection);
      });
    });
    setHeaderHeightVar();
    window.addEventListener("resize", function () {
      setHeaderHeightVar();
      positionTabThumb();
    });
    /* fonts shift widths after load — reposition once they settle */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(positionTabThumb);
    positionTabThumb();
  }

  /* Sticky bar always mirrors the ACTIVE collection's selection. */
  function updateStickyBar() {
    var img = $("#sticky-cta img");
    var b, priceVal;
    if (activeCollection === "indoor") {
      b = getIndoorBundle(indoorState.bundleId);
      priceVal = b.price;
      $("#sticky-bundle-name").textContent = b.qty + "x — " + b.name;
      if (img) { img.src = indoorAssetUrl(getIndoorColor(indoorState.colorId).image + ".webp"); img.onerror = function () { this.style.visibility = "hidden"; }; }
    } else {
      b = getBundle(state.bundleId);
      priceVal = outdoorPricing(state.bundleId).price; /* style-aware */
      $("#sticky-bundle-name").textContent = b.qty + "x — " + b.name;
      if (img) { img.style.visibility = ""; img.onerror = null; img.src = assetUrl("1.webp"); }
    }
    $("#sticky-price").textContent = money(priceVal);
    /* Global free-shipping rule: every product/bundle ships complimentary. */
    $("#sticky-shipping").textContent = "· Complimentary Shipping";
  }

  /* ---------- 4. mobile sticky CTA scroll detector ---------- */

  function initStickyCta() {
    var bar = $("#sticky-cta");
    /* Sticky bar and the hero CTAs it tracks only exist on the landing page. */
    if (!bar || !($("#main-cta") || $("#main-cta-in"))) return;
    var ticking = false;

    function update() {
      /* track the CTA of whichever collection tab is visible */
      var heroCta = activeCollection === "indoor" ? $("#main-cta-in") : $("#main-cta");
      /* show only once the hero CTA has been scrolled up out of view */
      var show = heroCta.getBoundingClientRect().bottom < 0;
      bar.classList.toggle("translate-y-full", !show);
      bar.setAttribute("aria-hidden", String(!show));
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  /* ---------- 5. checkout redirect (Shopify cart permalinks) ---------- */

  function trackInitiateCheckout(payload) {
    if (typeof fbq === "function") fbq("track", "InitiateCheckout", payload);
    if (typeof ttq !== "undefined" && ttq.track) ttq.track("InitiateCheckout", payload);
  }
  window.trackInitiateCheckout = trackInitiateCheckout;

  function initiateCheckout(bundleId) {
    var b, checkoutUrl, unitedPrice, variantData;
    var payload = { collection: activeCollection, currency: MONEY.code };

    if (activeCollection === "indoor") {
      b = getIndoorBundle(bundleId);
      var col = getIndoorColor(indoorState.colorId);
      unitedPrice = b.price;
      payload.styleId = "indoor";
      payload.styleName = C.indoor.product.shortName;
      payload.colorId = col.id;
      payload.colorName = col.name;
      variantData = resolveIndoorVariant(bundleId, indoorState.colorId);
      checkoutUrl = buildIndoorCheckoutUrl(bundleId, indoorState.colorId);
    } else {
      var s = getStyle(state.styleId);
      b = getBundle(bundleId);
      unitedPrice = outdoorPricing(bundleId).price;
      payload.styleId = s.id;
      payload.styleName = s.name;
      variantData = resolveOutdoorVariant(state.styleId, bundleId);
      checkoutUrl = buildCheckoutUrl(state.styleId, bundleId);
    }

    payload.package = b.id;
    payload.name = b.name;
    payload.quantity = b.qty;
    payload.totalPrice = unitedPrice;
    payload.shippingTier = "free";
    payload.shippingCost = 0;
    payload.orderTotal = Number(unitedPrice.toFixed(2));

    if (!variantData || !checkoutUrl) {
      if (activeCollection === "indoor") {
        alert("The indoor product will be available for purchase soon! Sign up for our newsletter to be notified.");
      }
      return;
    }

    payload.checkoutUrl = checkoutUrl;
    trackInitiateCheckout(payload);

    /* Add to cart via AJAX then redirect straight to checkout */
    if (isShopify) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantData.id), quantity: variantData.qty }] })
      }).then(function (resp) {
        if (resp.ok) window.location.href = '/checkout';
        else window.location.href = checkoutUrl;
      }).catch(function () {
        window.location.href = checkoutUrl;
      });
      return;
    }

    window.location.href = checkoutUrl;
  }
  window.initiateCheckout = initiateCheckout;

  /* Route CTA clicks through the active collection's selected bundle. */
  function checkoutActive() {
    initiateCheckout(activeCollection === "indoor" ? indoorState.bundleId : state.bundleId);
  }

  /* Express checkout buttons — same flow as main CTA */
  ["express-applepay", "express-paypal"].forEach(function (id) {
    var btn = $("#" + id);
    if (btn) btn.addEventListener("click", function () { checkoutActive(); });
  });
  ["express-applepay-in", "express-paypal-in"].forEach(function (id) {
    var btn = $("#" + id);
    if (btn) btn.addEventListener("click", function () { checkoutActive(); });
  });

  /* ---------- 6. shopping cart ---------- */

  var cartData = { items: [], item_count: 0, total_price: 0 };

  function cartMoney(cents) { return MONEY.format(cents / 100); }

  function fetchCart(cb) {
    if (!isShopify) {
      try { cartData = JSON.parse(localStorage.getItem("staroled_cart")) || { items: [], item_count: 0, total_price: 0 }; }
      catch (e) { cartData = { items: [], item_count: 0, total_price: 0 }; }
      if (cb) cb(cartData);
      return;
    }
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartData = cart; if (cb) cb(cart); })
      .catch(function () { if (cb) cb(cartData); });
  }

  function saveLocalCart() {
    var count = 0, total = 0;
    for (var i = 0; i < cartData.items.length; i++) {
      count += cartData.items[i].quantity;
      total += cartData.items[i].price * cartData.items[i].quantity;
    }
    cartData.item_count = count;
    cartData.total_price = total;
    localStorage.setItem("staroled_cart", JSON.stringify(cartData));
  }

  function addToCart(variantId, qty, info, cb) {
    if (!isShopify) {
      var vid = String(variantId);
      var found = false;
      for (var i = 0; i < cartData.items.length; i++) {
        if (String(cartData.items[i].id) === vid) {
          cartData.items[i].quantity += qty;
          found = true;
          break;
        }
      }
      if (!found) {
        cartData.items.push({
          id: Number(vid), key: vid + ":" + Date.now(),
          title: info.title, variant_title: info.variant_title || "",
          quantity: qty, price: info.price, image: info.image || ""
        });
      }
      saveLocalCart();
      if (cb) cb(cartData);
      return;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function () { fetchCart(cb); })
      .catch(function () { if (cb) cb(cartData); });
  }

  function changeCartItem(key, qty, cb) {
    if (!isShopify) {
      if (qty <= 0) {
        cartData.items = cartData.items.filter(function (it) { return it.key !== key; });
      } else {
        for (var i = 0; i < cartData.items.length; i++) {
          if (cartData.items[i].key === key) { cartData.items[i].quantity = qty; break; }
        }
      }
      saveLocalCart();
      if (cb) cb(cartData);
      return;
    }
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { fetchCart(cb); })
      .catch(function () { if (cb) cb(cartData); });
  }

  function addToCartActive() {
    var variantData, info;
    if (activeCollection === "indoor") {
      variantData = resolveIndoorVariant(indoorState.bundleId, indoorState.colorId);
      if (!variantData) {
        alert("The indoor product will be available for purchase soon! Sign up for our newsletter to be notified.");
        return;
      }
      var col = getIndoorColor(indoorState.colorId);
      var bun = getIndoorBundle(indoorState.bundleId);
      info = {
        title: C.indoor.product.shortName,
        variant_title: col.name + " · " + bun.name,
        price: Math.round(bun.price * 100),
        image: indoorAssetUrl(col.image + ".webp")
      };
    } else {
      variantData = resolveOutdoorVariant(state.styleId, state.bundleId);
      if (!variantData) return;
      var sty = getStyle(state.styleId);
      var bun = getBundle(state.bundleId);
      var pr = outdoorPricing(state.bundleId);
      info = {
        title: C.product.shortName,
        variant_title: sty.name + " · " + bun.name,
        price: Math.round(pr.price * 100),
        image: assetUrl(sty.image + ".webp")
      };
    }
    addToCart(variantData.id, variantData.qty, info, function (cart) {
      renderCartDrawer(cart);
      updateCartBadge(cart);
      openCartDrawer();
    });
  }

  function openCartDrawer() {
    var el = $("#cart-drawer");
    if (!el) return;
    el.setAttribute("aria-hidden", "false");
    el.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    var el = $("#cart-drawer");
    if (!el) return;
    el.classList.remove("open");
    el.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function updateCartBadge(cart) {
    var badge = $("#cart-badge");
    if (!badge) return;
    var count = cart.item_count || 0;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function renderCartDrawer(cart) {
    var itemsEl = $("#cart-items");
    var emptyEl = $("#cart-empty");
    var footerEl = $("#cart-drawer-footer");
    var countEl = $("#cart-drawer-count");
    if (!itemsEl) return;

    var items = cart.items || [];
    var hasItems = items.length > 0;

    emptyEl.style.display = hasItems ? "none" : "";
    footerEl.hidden = !hasItems;
    countEl.textContent = cart.item_count || 0;

    if (!hasItems) { itemsEl.innerHTML = ""; return; }

    itemsEl.innerHTML = items.map(function (item) {
      var imgSrc = item.image || "";
      if (imgSrc && imgSrc.indexOf("//") === 0) imgSrc = "https:" + imgSrc;
      var lineTotal = item.price * item.quantity;

      return (
        '<div class="cart-item" data-key="' + (item.key || item.id) + '">' +
          '<img src="' + imgSrc + '" alt="" class="cart-item-img" width="72" height="72" onerror="this.style.display=\'none\'">' +
          '<div class="cart-item-details">' +
            '<p class="cart-item-title">' + item.title + '</p>' +
            (item.variant_title ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '') +
            '<p class="cart-item-unit-price">' + cartMoney(item.price) + ' each</p>' +
            '<div class="cart-qty-controls">' +
              '<button type="button" class="cart-qty-btn" data-action="decrease" aria-label="Decrease quantity">−</button>' +
              '<span class="cart-qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-qty-btn" data-action="increase" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-item-right">' +
            '<span class="cart-item-line-price">' + cartMoney(lineTotal) + '</span>' +
            '<button type="button" class="cart-item-remove" data-action="remove" aria-label="Remove ' + item.title + '">' +
              '<i class="fa-solid fa-trash-can"></i>' +
            '</button>' +
          '</div>' +
        '</div>'
      );
    }).join("");

    $("#cart-subtotal-price").textContent = cartMoney(cart.total_price || 0);
  }

  function initCart() {
    var toggle = $("#cart-toggle");
    if (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        if (cartData.item_count > 0) {
          openCartDrawer();
        } else {
          var sel = activeCollection === "indoor" ? "#bundle-container-in" : "#bundle-container";
          var t = $(sel);
          if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }

    $$("[data-cart-close]").forEach(function (el) {
      el.addEventListener("click", closeCartDrawer);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && $("#cart-drawer") && $("#cart-drawer").classList.contains("open")) closeCartDrawer();
    });

    var itemsContainer = $("#cart-items");
    if (itemsContainer) {
      itemsContainer.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-action]");
        if (!btn) return;
        var itemEl = btn.closest(".cart-item");
        if (!itemEl) return;
        var key = itemEl.dataset.key;
        var action = btn.dataset.action;
        var currentQty = 0;
        for (var i = 0; i < cartData.items.length; i++) {
          var ik = String(cartData.items[i].key || cartData.items[i].id);
          if (ik === key) { currentQty = cartData.items[i].quantity; break; }
        }
        var newQty = action === "increase" ? currentQty + 1 : action === "decrease" ? currentQty - 1 : 0;
        changeCartItem(key, newQty, function (cart) {
          renderCartDrawer(cart);
          updateCartBadge(cart);
        });
      });
    }

    var checkoutBtn = $("#cart-checkout-btn");
    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", function () {
        trackInitiateCheckout({
          collection: activeCollection, currency: MONEY.code,
          totalPrice: (cartData.total_price || 0) / 100,
          itemCount: cartData.item_count || 0
        });
      });
    }

    fetchCart(function (cart) {
      renderCartDrawer(cart);
      updateCartBadge(cart);
    });
  }

  /* ---------- misc: smooth-scroll helpers ---------- */

  function initScrollButtons() {
    $$("[data-scroll-to]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var sel = btn.dataset.scrollTo;
        /* bundle shortcuts resolve to the active collection's selector */
        if (sel === "#bundle-container" && activeCollection === "indoor") sel = "#bundle-container-in";
        var target = $(sel);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }

  /* ---------- boot ---------- */

  function init() {
    /* Must run before any renderer reads a price. */
    applyPresentmentPrices();

    /* The landing-page renderers below write directly into elements that only
       exist on templates/index.liquid. The layout loads this script on EVERY
       template (policy pages, customer accounts, /pages/*), so without this
       guard the first renderer throws on those pages and every later
       initialiser — including the cart drawer — never runs. */
    var isLandingPage = !!document.getElementById("hero-headline");

    if (isLandingPage) {
      renderHero();
      renderTrustBadges();
      renderPainPleasure();
      renderTestimonials();
      renderGuarantee();
      renderFAQ();
      initGallery();
      renderStyles();
      selectStyle(state.styleId);
      renderBundles();
      selectBundle(state.bundleId);

      /* indoor collection */
      renderIndoorHero();
      initIndoorGallery();
      renderIndoorColors();
      selectIndoorColor(indoorState.colorId);
      renderIndoorBundles();
      selectIndoorBundle(indoorState.bundleId);
      initCollectionTabs();
    }

    if (isLandingPage) {
      initGalleryArrows();
      initLightbox();
      renderCheckoutBadges();
      renderStockBadge("#stock-badge", C.scarcity.outdoorCount);
      renderStockBadge("#stock-badge-in", C.scarcity.indoorCount);
    }

    /* Global — these exist in layout/theme.liquid on every template and are
       individually null-safe, so they run everywhere. */
    initModals();
    initNewsletter();
    initBuyJump();
    initStickyCta();
    initScrollButtons();

    var outdoorForm = $("#outdoor-cart-form");
    if (outdoorForm) {
      outdoorForm.addEventListener("submit", function (e) {
        e.preventDefault();
        addToCartActive();
      });
    }

    var indoorForm = $("#indoor-cart-form");
    if (indoorForm) {
      indoorForm.addEventListener("submit", function (e) {
        e.preventDefault();
        addToCartActive();
      });
    }

    var stickyBuy = $("#sticky-buy-btn");
    if (stickyBuy) stickyBuy.addEventListener("click", addToCartActive);

    initCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
